import ViewerCore from './lib/viewer-core';
import Downloader from './lib/viewer-downloader';
import ElemResizer from './lib/viewer-ui-element-resizer';
import Slider from './lib/viewer-ui-slider';
import TabHelper from './lib/viewer-ui-tab-helper';
import ThumbList from './lib/viewer-ui-thumblist';
import Dialog from './lib/viewer-ui-dialog';
import _userAgent from './lib/useragent';
import $ from 'jquery';
import 'jquery-lazyload';

class RoDAViewer {
    constructor(args) {

        var self = this;

        this._viewer = new ViewerCore(args.mainViewerId, JSON.parse(args.tileSources), args.initialPage, args.watermarkUrl, args.watermarkPosition, this._confirmSelection.bind(this), 'spinner-overlay');

        document.addEventListener('resize', () => {
            setTimeout(this._viewer.mainViewer.raiseEvent('resize'), 500);
        }); 

        //#region 画像フィルター系

        if (_userAgent !== 'ie') {

            this._timer = null;
            this._filters = [
                {
                    filterName: 'brightness',
                    min: -255,
                    max: 255,
                    defaultValue: 0,
                    step: 1,
                    isSlider: true,
                    isAdd () {
                        const value = parseFloat(document.getElementById('brightness-slider').value);
                        return value !== this.defaultValue;
                    },
                    processor () {
                        const value = parseFloat(document.getElementById('brightness-slider').value);
                        return OpenSeadragon.Filters.BRIGHTNESS(value);
                    }
                },
                {
                    filterName: 'saturation',
                    min: -100,
                    max: 100,
                    defaultValue: 0,
                    step: 1,
                    isSlider: true,
                    isAdd () {
                        const value = parseFloat(document.getElementById('saturation-slider').value);
                        return value !== this.defaultValue;
                    },
                    processor () {
                        const value = parseFloat(document.getElementById('saturation-slider').value);
                        return self._saturationFilter(value);
                    }
                },
                {
                    filterName: 'contrast',
                    min: -100,
                    max: 100,
                    defaultValue: 0,
                    step: 1,
                    isSlider: true,
                    isAdd () {
                        const value = parseFloat(document.getElementById('contrast-slider').value);
                        return value !== this.defaultValue;
                    },
                    processor () {
                        const value = parseFloat(document.getElementById('contrast-slider').value);
                        return self._contrastFilter(value);
                    }
                },
                {
                    filterName: 'gamma',
                    min: 0,
                    max: 5,
                    defaultValue: 1,
                    step: 0.1,
                    isSlider: true,
                    isAdd () {
                        const value = parseFloat(document.getElementById('gamma-slider').value);
                        return value !== this.defaultValue;
                    },
                    processor () {
                        const value = parseFloat(document.getElementById('gamma-slider').value);
                        return OpenSeadragon.Filters.GAMMA(value);
                    }
                },
                {
                    filterName: 'greyscale',
                    isSlider: false,
                    isAdd () {
                        return document.querySelector('.filter-button[data-effect-type=greyscale]').getAttribute('aria-pressed') === 'true';
                    },
                    processor () {
                        return OpenSeadragon.Filters.GREYSCALE();
                    }
                },
                {
                    filterName: 'invert',
                    isSlider: false,
                    isAdd () {
                        return document.querySelector('.filter-button[data-effect-type=invert]').getAttribute('aria-pressed') === 'true';
                    },
                    processor () {
                        return OpenSeadragon.Filters.INVERT();
                    }
                }
            ];

            this._createFilterSliders();
        }
        else {
            const filterItem = document.getElementsByClassName('image-filter');
            for (let i = 0; i < filterItem.length; i++) {
                filterItem[i].style.display = 'none';
            }
        }

        //#endregion

        //#region ボタン初期化

        const buttonList = document.getElementsByTagName('button');
        for (let i = 0; i < buttonList.length; i++) {
            const button = buttonList[i];

            if (button.getAttribute('data-viewer-command')) {
                this._registClickEventForHasCommand(button);
            }
            else if (button.getAttribute('aria-expanded')) {
                this._registClickEventForHasExpanded(button);
            }

            this._registMouseEventForButton(button);
        }

        const tabList = document.querySelectorAll('[role="tablist"]');
        for (let i = 0; i < tabList.length; i++) {
            const tab = tabList[i];

            if (tab.classList.contains('filter-list')) {
                this._filterTab = new TabHelper(tab);
            }
            else {
                new TabHelper(tab);
            }
        }

        //#endregion

        //#region ページ系初期化

        // コンテンツが複数ページを有する場合のイベントハンドラの登録
        if (this._viewer.totalPagesCount > 1) this._initPaging();

        //#endregion

        //#region 回転系の初期化

        this._rotateSlider = new Slider('rotate-slider', this._setRotation.bind(this));
        this._viewer.addEventListener('changeRotate', this._setRotationInfo.bind(this));

        //#endregion

        //#region フルスクリーン機能の初期化

        document.addEventListener("webkitfullscreenchange", this._changeFullscreenEventHandler.bind(this), false);
        document.addEventListener("mozfullscreenchange", this._changeFullscreenEventHandler.bind(this), false);
        document.addEventListener("MSFullscreenChange", this._changeFullscreenEventHandler.bind(this), false);
        document.addEventListener("fullscreenchange", this._changeFullscreenEventHandler.bind(this), false);

        //#endregion

        //#region UI系の初期化

        this._isUILock = false;
        this._beforeNavigatorState = false;

        this._hideStart = setTimeout(this._hideUI.bind(this), 3000);

        this._viewer.mainViewer.addHandler('canvas-click', this._toggleUI.bind(this));

        const uiElements = document.querySelectorAll('[data-auto-hide]');
        const uiLength = uiElements.length;
        for (let i = 0; i < uiLength; i = i + 1) {
            const uiElem = uiElements[i];

            uiElem.addEventListener('mouseover', this._mouseOverEvent.bind(this), false);
            uiElem.addEventListener('mouseout', this._mouseOutEvent.bind(this), false);
        }

        //#endregion
    }

    //#region 各種初期化系

    _initPaging() {

        this._pageInfoForms = document.getElementsByClassName('current-page-number');
        const changeEventName = _userAgent !== 'ie' ? 'change' : 'mouseup';

        for (let i = 0; i < this._pageInfoForms.length; i++) {
            const pageForm = this._pageInfoForms[i];
            pageForm.addEventListener(changeEventName, this._directPageInput.bind(this), false);
            if (_userAgent === 'ie') {
                pageForm.addEventListener('blur', this._directPageInput.bind(this), false);
                pageForm.addEventListener('keyup', this._directPageInput.bind(this), false);
            }
        }

        // ページが変更された場合のイベントを登録する。
        this._viewer.addEventListener('changePage', this._changePageEventHandler.bind(this));

        //#region サムネイル系初期化

        this._sidebarThumbList = new ThumbList('sidebar-thumbnail-list-inner', 'column');
        this._bottomThumbList = new ThumbList('bottom-thumbnail-list-inner', 'row');

        const thumbnailList = document.getElementsByClassName('thumb');
        for (let k = 0; k < thumbnailList.length; k++) {
            const thumb = thumbnailList[k];

            this._registClickEventForHasCommand(thumb);
            this._registMouseEventForButton(thumb);

            thumb.addEventListener('click', this._sidebarContentClick, false);
        }

        new ElemResizer('sidebar', 'sidebar-resizer');

        $('.bottom-lazy').lazyload({
            container: $('#bottom-thumbnail-list-inner'),
            effect: 'fadeIn',
            failure_limit: 1000,
            skip_invisible: true,
            threshold: 300
            //load: function (e) {
            //    $(this).css('visibility', 'visible');
            //    $(this).next('svg').remove();
            //}
        });

        $('.side-lazy').lazyload({
            container: $('#sidebar-thumbnail-list-inner'),
            effect: 'fadeIn',
            failure_limit: 1000,
            skip_invisible: true,
            threshold: 300
            //load: function (e) {
            //    $(this).css('visibility','visible');
            //    $(this).next('svg').remove();
            //}
        });
         //lazyload();

        //#endregion
    }

//#endregion

//#region ボタン関係

/**
 * コマンドを実行するイベントハンドラを登録します。
 * @param {HTMLElement} button ボタン要素
 */
    _registClickEventForHasCommand(button) {
        'use strict';

        switch (button.dataset.viewerCommand) {

            case 'goPrevPage':
                button.addEventListener('click', this.goPrevPage.bind(this), false);
                break;

            case 'goNextPage':
                button.addEventListener('click', this.goNextPage.bind(this), false);
                break;

            case 'setPage':
                const page = parseInt(button.dataset.viewerCommandArg);
                button.addEventListener('click', this._viewer.goToPage.bind(this._viewer, page, true), false);
                break;

            case 'zoomOut':
                button.addEventListener('click', this._viewer.zoomTo.bind(this._viewer, 0.5), false);
                break;

            case 'zoomIn':
                button.addEventListener('click', this._viewer.zoomTo.bind(this._viewer, 2.0), false);
                break;

            case 'fitHome':
                button.addEventListener('click', this._viewer.goHome.bind(this._viewer, false), false);
                break;

            case 'fitVertical':
                button.addEventListener('click', this._viewer.fitVertically.bind(this._viewer), false);
                break;

            case 'fitHorizontal':
                button.addEventListener('click', this._viewer.fitHorizontally.bind(this._viewer), false);
                break;

            case 'rotate':
                button.addEventListener('click', this._setRotate.bind(this), false);
                break;

            case 'setRotate':
                const degrees = parseInt(button.dataset.viewerCommandArg);
                button.addEventListener('click', this._viewer.setRotation.bind(this._viewer, degrees, true), false);
                break;

            case 'toggleNavigator':
                button.addEventListener('click', this._toggleNavigator.bind(this), false);
                break;

            case 'toggleFullscreen':
                var enableFullscreen = document.fullscreenEnabled || document.msFullscreenEnabled || document.mozFullScreenEnabled || document.webkitFullscreenEnabled;
                if (enableFullscreen) {
                    this._fullScreenButton = button;
                    button.addEventListener('click', this.toggleFullscreen.bind(this), false);
                }
                else {
                    button.style.display = 'none';
                    button.setAttribute('aria-hidden', 'true');
                }
                break;

            case 'openInfoDialog':
                this._infoDialog = new Dialog('info-dialog', true, true, 'info-close-button');
                button.addEventListener('click', this._infoDialog.open.bind(this._infoDialog), false);
                break;

            case 'openDownloadDialog':
                this._initDownload(button);
                break;

            case 'openQuoteDialog':
                this._initQuote(button);
                break;

            case 'effect':
                button.addEventListener('click', this.imageAdjustment.bind(this), false);
                break;

            case 'effect-reset':
                button.addEventListener('click', this._resetFilters.bind(this), false);
                break;

            default:
        }

        if (button.dataset.clickToClose === 'true') {
            button.addEventListener('click', this._closeMenuDialog.bind(this), false);
        }
    }

/**
 * 要素の開閉を行うイベントハンドラを登録します。
 * @param {HTMLButtonElement} button ボタン要素
 */
    _registClickEventForHasExpanded(button) {
        'use strict';

        button.addEventListener('click', this._clickEventForHasExpanded.bind(this), false);
    }

/**
 *  タブの切り替えを行うイベントハンドラを登録します。
 *  @param {HTMLButtonElement} button ボタン要素
 */
    _registClickEventForTab(button) {
        'use strict';

        button.addEventListener('click', this.toggleTab.bind(this), false);
    }

/**
 *  ボタンに対するマウス操作のイベントハンドラを登録します。
 *  @param {HTMLElement} button ボタン要素
 */
    _registMouseEventForButton(button) {
        'use strict';

        if (_userAgent !== 'ios' && _userAgent !== 'android') button.addEventListener('focus', this._mouseOverEvent.bind(this), false);
        button.addEventListener('blur', this._mouseOutEvent.bind(this), false);
        button.addEventListener('touchend', this._mouseOutEvent.bind(this), false);
        button.addEventListener('mouseover', this._mouseOverEvent.bind(this), false);
        button.addEventListener('mouseout', this._mouseOutEvent.bind(this), false);
        button.addEventListener('mouseup', this._mouseOutEvent.bind(this), false);
    }

/**
 * ボタンがマウスオーバーされた時のイベント。
 * hoverクラスの付与と（あれば）ツールチップの表示を行う。
 * @param {MouseEvent} event MouseEvent
 */
    _mouseOverEvent(event) {
        'use strict';

        const element = event.currentTarget;

        if (this._isUILock) return;

        // hoverクラスの付与。
        element.classList.add('hover');

        if (element.tagName.toLowerCase() !== 'button') return;

        // ツールチップの表示
        // 端末のOSがiOSとandroidの場合はツールチップを表示せずに抜ける。
        if (_userAgent === 'ios' || _userAgent === 'android') return;

        const tooltipId = element.dataset.tooltipId;
        if (!tooltipId) return;

        const tooltip = document.getElementById(tooltipId);
        if (!tooltip) return;

        tooltip.setAttribute('aria-hidden', 'false');

        const rect = element.getBoundingClientRect();
        const tpRect = tooltip.getBoundingClientRect();

        tooltip.style.top = '';
        tooltip.style.bottom = '';
        tooltip.style.left = '';
        tooltip.style.right = '';

        const elemCenter = rect.left + (rect.width / 2);
        const tpLeft = elemCenter - (tpRect.width / 2);

        if (rect.left === 0) {
            tooltip.style.left = 0;
        } else if (window.innerWidth < tpLeft + tpRect.width) {
            tooltip.style.right = 0;
        } else {
            tooltip.style.left = tpLeft + 'px';
        }

        if (rect.y + rect.height > window.innerHeight / 2) {
            tooltip.style.top = rect.top - tpRect.height + 'px';
        }
        else {
            tooltip.style.top = rect.top + rect.height + 'px';
        }
    }

/**
 * ボタンがマウスオーバーされた時のイベント。
 * hoverクラスの除去と（あれば）ツールチップを非表示にする。
 * @param {MouseEvent} event MouseEvent
 */
    _mouseOutEvent(event) {
        'use strict';

        const element = event.currentTarget;

        // hoverクラスの削除。
        element.classList.remove('hover');
        element.blur();

        // ツールチップの表示
        // 端末のOSがiOSとandroidの場合はツールチップを表示せずに抜ける。
        if (_userAgent === 'ios' || _userAgent === 'android') return;

        // ツールチップのIDを取得。
        const tooltipId = element.dataset.tooltipId;
        if (!tooltipId) return;

        // ツールチップ要素を取得。
        const tooltip = document.getElementById(tooltipId);
        if (!tooltip) return;

        // 200ms後にツールチップを表示する。
        if (this._tooltipTimer !== null) window.clearTimeout(this._tooltipTimer);
        this._tooltipTimer = null;
        tooltip.setAttribute('aria-hidden', 'true');
    }

/**
 * 要素の開閉を行うボタンをクリックした際のイベント。
 * @param {MouseEvent} event イベント。
 */
    _clickEventForHasExpanded(event) {
        'use strict';

        const element = event.currentTarget;
        const isExpanded = element.getAttribute('aria-expanded') === 'true';
        const ctrlElemId = element.getAttribute('aria-controls');

        element.setAttribute('aria-expanded', !isExpanded);
        document.getElementById(ctrlElemId).setAttribute('aria-hidden', isExpanded);

        const toggleButtonId = element.dataset.toggleButtonId;
        if (toggleButtonId) {
            const toggleButton = document.getElementById(toggleButtonId);
            if (toggleButton && toggleButton.getAttribute('aria-expanded') === 'true') {
                const tCtrlElemId = toggleButton.getAttribute('aria-controls');
                if (tCtrlElemId) {
                    const tCtrlElem = document.getElementById(tCtrlElemId);
                    if (tCtrlElem) {
                        toggleButton.setAttribute('aria-expanded', 'false');
                        tCtrlElem.setAttribute('aria-hidden', 'true');
                    }
                }
            }
        }

        if (element.dataset.closed) {
            const closeElem = document.getElementById(element.dataset.closed);
            if (closeElem) {
                closeElem.setAttribute('aria-expanded', 'false');
                document.getElementById(closeElem.getAttribute('aria-controls')).setAttribute('aria-hidden', 'true');
            }
        }

        if (ctrlElemId === 'sidebar') {
            document.querySelector('.toolbar').classList.toggle('show-sidebar');
            document.getElementById('viewer-container').classList.toggle('show-sidebar');
            document.getElementById('bottom-toolbar').classList.toggle('show-sidebar');

            const overlay = document.getElementById('sidebar-overlay');
            overlay.setAttribute('aria-hidden', isExpanded);

            if (isExpanded) {
                if (this._sidebarFunc !== null && this._sidebarFunc !== undefined) {
                    overlay.removeEventListener('click', this._sidebarFunc);
                    this._sidebarFunc = null;
                }
            }
            else {
                this._sidebarFunc = this._elementClickTrigger.bind(this, element);
                overlay.addEventListener('click', this._sidebarFunc, false);
            }
        }

        if (this._hideStart) clearTimeout(this._hideStart);

        // ツールチップのIDを取得。
        const tooltipId = element.dataset.tooltip;
        if (!tooltipId) return;

        // ツールチップ要素を取得。
        const tooltip = document.getElementById(tooltipId);
        if (!tooltip) return;

        const msg = isExpanded ? tooltip.dataset.notExpandedMsg : tooltip.dataset.expandedMsg;
        if (!msg) return;

        tooltip.textContent = msg;
    }

    _elementClickTrigger(element) {
        'use strict';

        element.click();
    }

//#endregion

//#region ページ関係

/**
 * ページを直接入力した際のイベントハンドラ。
 * @param {Event} event イベント。
 */
    _directPageInput(event) {

        // イベント種別がキーアップの場合はEnter以外は反応しない。
        if (event.type === 'keyup' && event.keyCode !== 13) return;

        const pageNum = parseInt(event.target.value);
        if (isNaN(pageNum) || pageNum < 1 || pageNum > this._viewer.totalPages) {
            // 入力されたページ番号が不正であった場合は現在のページ番号をセットする。
            event.target.value = this._viewer.getCurrentPage();
        }
        else if (pageNum !== this._viewer.getCurrentPage()) {
            try {
                this._viewer.goToPage(pageNum, true);
            }
            catch (e) {
                // 入力されたページ番号が不正であった場合は現在のページ番号をセットする。
                event.currentTarget.value = this._viewer.getCurrentPage();
            }
        }
    }

    /**
     * ページが変更された際のイベントハンドラ。
     * ページ番号の補正、スライダー位置の補正等を行う。
     * 
     */
    _changePageEventHandler(event) {

        const currentPage = event.detail.page;
        const hasNextPage = event.detail.existNextPage;

        // 最初のページである場合に前のページへ移動するボタンを無効化する。
        // 最初のページでない場合は逆に有効化を行う。
        const prevPages = document.getElementsByClassName('prev-page');
        const prevCount = prevPages.length;
        for (let i = 0; i < prevCount; i = i + 1) {
            prevPages[i].disabled = currentPage === 1;
        }

        // 最後のページである場合に後ろのページへ移動するボタンを無効化する。
        // 最後のページでない場合は逆に有効化を行う。
        const nextPages = document.getElementsByClassName('next-page');
        const nextCount = nextPages.length;
        for (let i = 0; i < nextCount; i = i + 1) {
            nextPages[i].disabled = !hasNextPage;
        }

        // サムネイルリストのページを変更する。
        this._sidebarThumbList.changePage(currentPage);
        this._bottomThumbList.changePage(currentPage);

        // フォームの設定を行う。
        for (let j = 0; j < this._pageInfoForms.length; j = j + 1) {
            const form = this._pageInfoForms[j];
            if (parseInt(form.value) !== currentPage) form.value = currentPage;
        }
    }

/**
* ページ番号を変更したURLを生成する。
* @param {Number} page ページ番号
* @return {string} URL。
*/
    _generateUrl(page) {
        if (!location.href.match(/[?&]p=\d{1,}/)) {
            if (!location.search) {
                return location.href + '?p=' + page;
            }
            else {
                return location.href + '&p=' + page;
            }
        }

        return location.href.replace(/[?&]p=\d{1,}/, function (match) {
            return match.charAt(0) + 'p=' + page;
        });
    }

//#endregion

//#region サムネイルリスト関係

    _sidebarContentClick() {
        'use strict';

        const isMobile = window.getComputedStyle(document.getElementById('sidebar-overlay'), '').visibility === 'visible';
        if (isMobile) document.getElementById('sidebar-toggle-button').click();
    }

//#endregion

//#region 回転系

/**
 * 画像角度回転ボタンが押された際のイベントハンドラ。
 * ボタンのdata-viewer-command-arg属性の値だけ回転させる。
 * @param {MouseEvent} event マウスイベント
 */
    _setRotate(event) {
        'use strict';

        const offset = parseInt(event.currentTarget.dataset.viewerCommandArg);
        const degrees = (offset + this._viewer.getRotation() + 360) % 360;

        this.setImageRotation(degrees, true);
    }

/**
 * 画像角度回転スライダーの値が変更された際のイベントハンドラ。
 * 画像の角度をinput要素のvalueに変更する。
 * @param {Event} event inputイベント。
 */
    _setRotation(event) {
        'use strict';

        if (event.type !== 'input' && event.type !== 'change') return;

        const degrees = parseInt(event.target.value);
        this.setImageRotation(degrees, false);
    }

/**
 * 画像角度が変更された際のイベントハンドラ。
 * 画像角度回転スライダーの値を画像角度と一致させる。
 * @param {CustomEvent} event イベント。
 */
    _setRotationInfo(event) {
        'use strict';

        // OpenSeadragonでは角度は0~360だが、スライダー上では-180~180であるので、変換を行う。
        const degrees = event.detail.degrees > 180 ? event.detail.degrees - 360 : event.detail.degrees;
        this._rotateSlider.setValue(degrees);
    }

//#endregion

//#region メニュー系

/**
 * メニューダイアログを閉じるイベント。
 * @param {MouseEvent} event マウスイベント
 */
    _closeMenuDialog(event) {
        'use strict';

        const button = document.querySelector('button[aria-controls="toolbar-menu"]');
        button.setAttribute('aria-expanded', 'false');

        document.getElementById('toolbar-menu').setAttribute('aria-hidden', 'true');
    }

//#endregion

//#region 引用系

/**
 * 引用の初期化を行います。
 * @param {HTMLButtonElement} button ボタン要素
 */
    _initQuote(button) {
        this._quoteAboutDialog = new Dialog('quote-about-dialog', true, true, 'quote-about-button');
        this._quoteDialog = new Dialog('quote-command', false, false);
        this._quotePreviewDialog = new Dialog('quote-preview-dialog', true, false, '');
        this._quoteResultDialog = new Dialog('quote-result-dialog', true, false, 'quote-close-button');

        button.addEventListener('click', this._quoteAboutDialog.open.bind(this._quoteAboutDialog), false);

        const startButton = document.getElementById('quote-about-button');
        startButton.addEventListener('click', this._startSelection.bind(this), false);

        document.getElementById('quote-confirm-button').addEventListener('click', this._viewer.confirmSelection.bind(this._viewer), false);
        document.getElementById('quote-redo-button').addEventListener('click', this._redoSelection.bind(this), false);
        document.getElementById('quote-cancel-button').addEventListener('click', this._endSelection.bind(this), false);

        document.getElementById('quote-regist-button').addEventListener('click', this._registQuoteUrl.bind(this), false);
        document.getElementById('quote-preview-cancel-button').addEventListener('click', this._redoSelection.bind(this), false);
    }

/**
* 引用を開始します。
*/
    _startSelection() {

        this._hideUI();
        this._isUILock = true;

        this._quoteDialog.open();
        this._viewer.setSelectionState(true);
    }

/**
 * 引用を中止します。
 */
    _endSelection() {

        this._isUILock = false;

        this._quoteDialog.close();
        this._viewer.setSelectionState(false);
    }

/**
 * 引用をやり直します。
 */
    _redoSelection() {
        this._quoteDialog.open();
        this._quotePreviewDialog.close();

        this._viewer.cancelSelection();
    }

    /**
     * 引用が確定した際のイベントハンドラ。
     * @param {Event} event イベント
     */
    _confirmSelection(event) {
        this._quoteDialog.close();
        this._showQuote(event.detail);
        //this._showQuotePreview(event.detail);
    }

    /**
     * URLを登録して、結果を表示します。
     * @param {string} url url
     */
    _showQuote(url) {
        const self = this;

        this._quotePreviewDialog.close();
        this._viewer.showLoadAnimation();

        const image = document.getElementById('quote-result');
        image.src = url;
        image.onload = function () {
            self._viewer.hiddenLoadAnimation();
            self._quoteResultDialog.open();
            document.getElementById('image-url').textContent = url;
            document.getElementById('image-tag').textContent = `<img src="${url}" alt="${document.getElementById('image-title').value}" >`;
        };
        image.onerror = function () {
            self._viewer.hiddenLoadAnimation();
            alert('画像の取得に失敗しました');
        };
       
        this._isUILock = false;
    }

    /**
     * プレビューを表示します。
     * @param {String} url 登録するURL。
     */
    _showQuotePreview(url) {
        const quoteSize = this._viewer.getSelectedRectSize();
        document.getElementById('quote-size').textContent = quoteSize.x + '×' + quoteSize.y;

        const preview = document.getElementById('quote-preview');
        preview.src = preview.dataset.src;

        console.log(url);
        this._quotePreviewDialog.open();
        this._imageUrl = url;

        const xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.responseType = 'blob';
        xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        xhr.onloadend = function(e) {
            if (xhr.status === 200) {
                const reader = new FileReader();
                reader.onloadend =function() {
                    preview.src = reader.result;
                };
                reader.readAsDataURL(xhr.response);
            }
            else {
                alert('画像の取得に失敗しました。');
            }
        }.bind(this);
        xhr.send();
    }

    /**
     * URLを登録して、結果を表示します。
     */
    _registQuoteUrl() {
        const self = this;

        this._quotePreviewDialog.close();
        this._viewer.showLoadAnimation();

        const image = document.getElementById('quote-result');
        image.onload = function() {
            self._viewer.hiddenLoadAnimation();
            self._quoteResultDialog.open();
        };
        image.onerror = function () {
            self._viewer.hiddenLoadAnimation();
            alert('画像の取得に失敗しました');
        };

        const permalinkUrl = document.getElementById('quote_url').value;

        const formData = new FormData();
        formData.append('url', this._imageUrl);

        const xhrObject = new XMLHttpRequest();
        xhrObject.open('POST', permalinkUrl, true);
        xhrObject.responseType = 'json';
        xhrObject.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        xhrObject.onloadend = function (e) {
            self._isUILock = false;
            const url = xhrObject.response.permalink;

            image.src = url;
            document.getElementById('image-url').textContent = url;
            document.getElementById('image-tag').textContent = `<img src="${url}" >`;
            console.log(`<img src="${url}" >`);
        };
        
        xhrObject.send(formData);
    }

//#endregion

//#region ダウンロード系

    /**
     * ダウンロードダイアログの初期化を行う。
     * @param {object} button ボタン
     */
    _initDownload(button) {

        this._downloadDialog = new Dialog('download-dialog', true, true, 'download-close-button');

        //const downloadUrl = document.getElementById('download_url');
        new Downloader(this._viewer.mainViewer, 'download-button', 'type', 'download', 'page-select', 'page-range');

        button.addEventListener('click', this._downloadDialog.open.bind(this._downloadDialog), false);
        document.getElementById('download').addEventListener('click', this._downloadDialog.close.bind(this._downloadDialog), false);
    }

//#endregion

//#region フルスクリーン

    /**
     * フルスクリーン変更イベントのイベントハンドラ。
     * @param {fullscreenchange} event フルスクリーン変更イベント。
     */
    _changeFullscreenEventHandler(event) {

        const isFullscreen = this._viewer.getFullscreenState();

        this._fullScreenButton.setAttribute('aria-pressed', isFullscreen);

        const buttonChildren = this._fullScreenButton.children;
        const buttonCount = buttonChildren.length;
        for (let i = 0; i < buttonCount; i = i + 1) {
            const buttonIcon = buttonChildren[i];
            if (buttonIcon.tagName === 'svg') {

                if (buttonIcon.classList) {
                    buttonIcon.classList.toggle('fa-compress');
                    buttonIcon.classList.toggle('fa-expand');
                }
                else {
                    try {
                        const classList = buttonIcon.getAttribute('class').split(' ');
                        const classCount = classList.length;

                        let classListStr = '';
                        for (let i = 0; i < classCount; i = i + 1) {
                            const className = classList[i];
                            if (className === 'fa-compress') {
                                classListStr += 'fa-expand ';
                            }
                            else if (className === 'fa-expand') {
                                classListStr += 'fa-compress ';
                            }
                            else {
                                classListStr += className + ' ';
                            }
                        }

                        buttonIcon.setAttribute('class', classListStr);
                    }
                    catch (e) {
                        console.log(e);
                    }
                }
            } else if (buttonIcon.classList.contains('menu-button-label')) {
                buttonIcon.textContent = isFullscreen ? '全画面モードの終了' : '全画面表示';
            }
        }
    }

//#endregion

//#region ナビゲータ

    _toggleNavigator(event) {
        this._viewer.toggleDisplayOfNavigator();
    }

//#endregion

//#region UI系

/**
 * UIの表示を切り替えるイベントハンドラ
 * @param {MouseEvent} event イベント。
 */
    _toggleUI(event) {
        'use strict';

        if (event.quick === false || this._isUILock === true) return;

        const container = document.getElementById('viewer-container');
        if (container.getAttribute('data-show-header') === 'true') {
            this._hideUI();
        }
        else {
            this._showUI();
        }
    }

/**
 * UIを非表示にする。 
 */
    _hideUI() {
        'use strict';

        if (this._isUILock === true) return;

        const uiElements = document.querySelectorAll('[data-auto-hide]');
        const uiLength = uiElements.length;

        for (let i = 0; i < uiLength; i = i + 1) {
            const uiElem = uiElements[i];
            if (uiElem.classList.contains('hover')) {
                setTimeout(this._hideUI.bind(this), 3000);
                return;
            }
        }

        for (let i = 0; i < uiLength; i = i + 1) {
            const uiElem = uiElements[i];

            uiElem.setAttribute('aria-hidden', true);
            if (uiElem.dataset.autoHide === 'hide-only') {
                const parent = document.querySelector('button[aria-controls="' + uiElem.id + '"]');
                if (parent) {
                    parent.setAttribute('aria-expanded', false);
                    parent.classList.remove('hover');

                    if (uiElem.id === 'sidebar-container') document.getElementById('viewer-container').classList.remove('show-sidebar');
                }
            }
        }

        document.getElementById('viewer-container').setAttribute('data-show-header', 'false');
        document.getElementById('navigator').setAttribute('data-show-header', 'false');
    }

/**
 * UIを表示する。 
 */
    _showUI() {
        'use strict';

        if (this._isUILock === true) return;

        const uiElements = document.querySelectorAll('[data-auto-hide="true"]');
        const uiLength = uiElements.length;

        for (let i = 0; i < uiLength; i = i + 1) {
            const uiElem = uiElements[i];

            uiElem.setAttribute('aria-hidden', false);
        }

        document.getElementById('viewer-container').setAttribute('data-show-header', 'true');
        document.getElementById('navigator').setAttribute('data-show-header', 'true');
    }

//#endregion

//#region フィルター

    _contrastFilter(adjustment) {
        if (adjustment < -100 || adjustment > 100) {
            throw new Error('Contrast adjustment must be between -100 and 100.');
        }
        adjustment = adjustment / 100 + 1;
        const intercept = 128 * (1 - adjustment);

        const precomputedContrast = [];
        for (var i = 0; i < 256; i++) {
            precomputedContrast[i] = Math.floor(i * adjustment + intercept);
        }
        return function (context, callback) {
            var imgData = context.getImageData(
                0, 0, context.canvas.width, context.canvas.height);
            var pixels = imgData.data;
            for (var i = 0; i < pixels.length; i += 4) {
                pixels[i] = precomputedContrast[pixels[i]];
                pixels[i + 1] = precomputedContrast[pixels[i + 1]];
                pixels[i + 2] = precomputedContrast[pixels[i + 2]];
            }
            context.putImageData(imgData, 0, 0);
            callback();
        };
    }

    _saturationFilter(adjustment) {
        if (adjustment < -100 || adjustment > 100) {
            throw new Error('Saturation adjustment must be between -100 and 100.');
        }
        adjustment += 100;
        adjustment = adjustment !== 0 ? adjustment / 100 : 0;

        const self = this;
        return function (context, callback) {
            const imgData = context.getImageData(0, 0, context.canvas.width, context.canvas.height);
            const pixels = imgData.data;
            for (let i = 0; i < pixels.length; i += 4) {
                const hsv = self._convertRGB2HSV(pixels[i], pixels[i + 1], pixels[i + 2]);
                hsv.s *= adjustment;

                const rgb = self._convertHSV2RGB(hsv.h, hsv.s, hsv.v);
                pixels[i] = rgb.r;
                pixels[i + 1] = rgb.g;
                pixels[i + 2] = rgb.b;
            }
            context.putImageData(imgData, 0, 0);
            callback();
        };
    }

    _convertRGB2HSV(r, g, b) {

        // RGBを0.0~1.0の浮動小数点モデルに変換する。
        r /= 255;
        g /= 255;
        b /= 255;

        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);

        const diff = max - min;
        let h = 0;
        let s = max === 0 ? 0 : diff / max;
        let v = max;

        if (diff > 0) {
            switch (max) {
                case r:
                    h = (g - b) / diff;
                    if (h < 0) h += 6;
                    break;

                case g:
                    h = (b - r) / diff + 2;
                    break;

                case b:
                    h = (r - g) / diff + 4;
                    break;
            }
            h /= 6;
        }

        return {
            h: h,
            s: s,
            v: v
        };
    }

    _convertHSV2RGB(h, s, v) {
        let r, g, b;

        const i = Math.floor(h * 6);
        const f = h * 6 - i;

        switch (i) {

            case 0:
                r = v;
                g = v * (1 - (1 - f) * s);
                b = v * (1 - s);
                break;

            case 1:
                r = v * (1 - s * f);
                g = v;
                b = v * (1 - s);
                break;

            case 2:
                r = v * (1 - s);
                g = v;
                b = v * (1 - (1 - f) * s);
                break;

            case 3:
                r = v * (1 - s);
                g = v * (1 - s * f);
                b = v;
                break;

            case 4:
                r = v * (1 - (1 - f) * s);
                g = v * (1 - s);
                b = v;
                break;

            case 5:
                r = v;
                g = v * (1 - s);
                b = v * (1 - s * f);
                break;
        }

        return {
            r: Math.floor(255 * r),
            g: Math.floor(255 * g),
            b: Math.floor(255 * b)
        };
    }

    _createFilterSliders() {
        const self = this;
        const panels = document.getElementById('bottom-image-filter');
        const selectedFilter = document.querySelector('.image-filter[aria-selected="true"]');
        this._filters.map(function (filter) {

            const filters = document.createElement('div');
            filters.id = filter.filterName + '-slider-panel';
            filters.classList.add('bottom-slider-panel');
            filters.setAttribute('aria-hidden', selectedFilter.getAttribute('aria-controls') !== filters.id);
            filters.setAttribute('role', 'tabpanel');

            const slider = document.createElement('input');
            slider.id = filter.filterName + '-slider';
            slider.classList.add('dialog-slider');
            slider.type = 'range';
            slider.min = filter.min;
            slider.max = filter.max;
            slider.step = filter.step || 1;
            slider.value = filter.defaultValue;

            const inputEventName = _userAgent === 'ie' || _userAgent === 'edge' ? 'change' : 'input';
            slider.addEventListener(inputEventName, self._updateFilter.bind(self), false);

            const resetButton = document.createElement('button');
            resetButton.classList.add('slider-button');
            resetButton.type = 'button';
            resetButton.dataset.effectType = filter.filterName;

            const i = document.createElement('i');
            i.classList.add('fas');
            i.classList.add('fa-sync-alt');

            resetButton.appendChild(i);
            filters.appendChild(slider);
            filters.appendChild(resetButton);

            resetButton.addEventListener('click', self._resetFilter.bind(self), false);

            panels.insertBefore(filters, panels.firstChild);
        });
    }

    _updateFilter() {

        var filters = [];
        if (this._timer !== null) clearTimeout(this._timer);

        setTimeout(function () {

            this._filters.map(function (filter) {
                if (filter.isAdd() === true) {
                    filters.push(filter.processor());
                }
            });


            this._viewer.mainViewer.setFilterOptions({
                filters: {
                    processors: filters
                },
                loadMode: 'sync'
            });

        }.bind(this), 50);
    }

    _resetFilter(event) {
        const id = event.currentTarget.dataset.effectType;
        this._filters.map(function (filter) {
            if (filter.filterName === id) {
                var filterInput = document.getElementById(filter.filterName + '-slider');
                filterInput.value = filter.defaultValue || 0;
            }
        });
        this._updateFilter();
    }

    _resetFilters(event) {
        if (_userAgent !== 'ie') {
            this._filters.map(function (filter) {
                if (filter.isSlider) {
                    var filterInput = document.getElementById(filter.filterName + '-slider');
                    filterInput.value = filter.defaultValue || 0;
                }
                else if (filter.isAdd()) {
                    const button = document.querySelector('.filter-button[data-effect-type=' + filter.filterName + ']');
                    if (button) button.click();
                }
            });
            this._updateFilter();
        }

        this._viewer.setRotation(0, true);
    }

    _debounce(func, intervel) {

        if (this._timer !== null) clearTimeout(this._timer);
        this._timer = setTimeout(function () {
            func.call();
        }, intervel);
    }


//#region パブリックメソッド

//#region ページ関係

/**
 * 前のページへ移動します。 
 */
    goPrevPage() {

        if (this._isUILock) return;

        const prevPage = this._viewer.getCurrentPage() - 1;
        this._viewer.goToPage(prevPage, true);
    }

/**
 * 前のページへ移動します。 
 */
    goNextPage() {

        if (this._isUILock) return;

        const nextPage = this._viewer.getCurrentPage() + 1;
        this._viewer.goToPage(nextPage, true);
    }

//#endregion

//#region 回転系

/**
 * 画像を回転させます。
 * @param {Number} degrees 設定する回転角。
 * @param {Boolean} [raiseEvent=true] イベントを発火させるか否か。
 */
    setImageRotation(degrees, raiseEvent) {
        const needRaiseEvent = raiseEvent === true;
        this._viewer.setRotation(degrees, needRaiseEvent);
    }

//#endregion

//#region フルスクリーン

/**
 * フルスクリーン表示を切り替えます。
 */
    toggleFullscreen() {

        if (this._fullScreenButton === undefined || this._fullScreenButton === null) throw new Error('この端末ではフルスクリーン表示がサポートされていません。');

        this._viewer.toggleFullScreen();
    }

//#endregion

    imageAdjustment(event) {

        const target = event.currentTarget;
        const isPressed = target.getAttribute('aria-pressed') === 'true';
        target.setAttribute('aria-pressed', !isPressed);

        this._updateFilter();
    }
}

window.RoDAViewer = RoDAViewer;
